import React from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Content } from '../../style';

const CardsStatus = ({
  nama, bobot, partisipasi, status,
}) => (
  <>
    <Content>
      <div className="cardMahasiswa">
        <Card className="text-center border-warning">
          <Card.Header className="textHeader">{nama}</Card.Header>
          <Card.Body>
            <Card.Text>
              Partisipasi :
              {' '}
              {partisipasi}
            </Card.Text>
            <Card.Text>
              Bobot :
              {' '}
              {bobot}
            </Card.Text>
            {status === 'Belum Terpenuhi'
              && (
                <div className="bgStatus">
                  <Card.Text className="textStatus">
                    {status}
                  </Card.Text>
                </div>
              )}

            {status === 'Terpenuhi'
              && (
                <div className="bgStatusSukses">
                  <Card.Text className="textStatusSukses">
                    {status}
                  </Card.Text>
                </div>
              )}
          </Card.Body>
        </Card>
      </div>
    </Content>
  </>
);

CardsStatus.defaultProps = {
  nama: '',
  bobot: '',
  partisipasi: '',
  status: '',
};

CardsStatus.propTypes = {
  nama: PropTypes.string,
  bobot: PropTypes.string,
  partisipasi: PropTypes.string,
  status: PropTypes.string,
};

export default CardsStatus;
